export default __webpack_public_path__ + "static/media/product-placeholder.689217e0.webp";